import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/axios'
import './plugins/bootstrap-vue'
import App from './App.vue'
import store from './store'

Vue.config.productionTip = false

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')

window.addEventListener('beforeunload', evt => {
  evt.preventDefault()
  evt.returnValue = 'Leaving this page will log you out.'
})
